import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SideBar } from './shared/components/side-bar/side-bar';
import { SuperAuthContainer } from './shared/components/super-auth-container/super-auth-container';
import { superAdminGuard } from './core/guards/super-admin-guard';
// import { Dashboard } from './Pages/main/dashboard/dashboard';
// import { Companies } from './Pages/main/companies/companies';
// import { Vendors } from './Pages/main/vendors/vendors';
// import { Users } from './Pages/main/users/users';
// import { VendorPayouts } from './Pages/main/vendor-payouts/vendor-payouts';
// import { Transactions } from './Pages/main/transactions/transactions';
// import { ReportsAndExperts } from './Pages/main/reports-and-experts/reports-and-experts';
// import { AdminsAndRoles } from './Pages/main/admins-and-roles/admins-and-roles';
// import { BillingAndRevenue } from './Pages/main/billing-and-revenue/billing-and-revenue';
export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./Pages/auth/login/login').then((m) => m.Login),
    data: {
      showForgotPasswordLink: false,
      showSignUpLink: false,
      currentApplication: 'super-admin',
    },
  },
  {
    path: 'account/activate',
    loadComponent: () =>
      import('@auth/activate-account/activate-account').then((m) => m.ActivateAccount)

  },
  {
    path: 'activate',
    loadComponent: () =>
      import('@auth/activate-account/activate-account').then((m) => m.ActivateAccount),
  },
  {
    path: 'password-reset-modal',
    loadComponent: () =>
      import('@auth/password-set-modal/password-set-modal').then((m) => m.PasswordSetModal),
  },
  {
    path: 'set-password',
    loadComponent: () =>
      import('@auth/reset-password/reset-password').then((m) => m.ResetPassword),
  },
  {
    path: 'vendor-activation',
    loadComponent: () =>
      import('@auth/activate-account/activate-account').then((m) => m.ActivateAccount),
  },

  // {
  //   path: '',
  //   component: SuperAuthContainer,
  //   children: [
  //     {
  //       path: 'set-password',
  //       loadComponent: () => import('@auth/set-password/set-password').then((m) => m.SetPassword),
  //     },
  //   ],
  // },

  {
    path: '',
    component: SideBar,
    canActivate: [superAdminGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./Pages/main/dashboard/dashboard').then((m) => m.Dashboard),
      },

      {
        path: 'organisation',
        loadComponent: () => import('./Pages/main/companies/companies.component').then((m) => m.CompaniesComponent),
      },

      {
        path: 'vendors',
        loadComponent: () => import('./Pages/main/vendors/vendors').then((m) => m.Vendors),
      },

      {
        path: 'users',
        loadComponent: () => import('./Pages/main/users/users').then((m) => m.Users),
      },

      {
        path: 'admins-roles',
        loadComponent: () =>
          import('./Pages/main/admins-and-roles/admins-and-roles').then((m) => m.AdminsAndRoles),
      },

      {
        path: 'billing-revenue',
        loadComponent: () =>
          import('./Pages/main/billing-and-revenue/billing-and-revenue').then(
            (m) => m.BillingAndRevenue,
          ),
      },

      {
        path: 'vendor-payouts',
        loadComponent: () =>
          import('./Pages/main/vendor-payouts/vendor-payouts').then((m) => m.VendorPayouts),
      },

      {
        path: 'transactions',
        loadComponent: () =>
          import('./Pages/main/transactions/transactions').then((m) => m.Transactions),
      },

      {
        path: 'reports-experts',
        loadComponent: () =>
          import('./Pages/main/reports-and-experts/reports-and-experts').then(
            (m) => m.ReportsAndExperts,
          ),
      },
    ],
  },

  {
    path: '**',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
